import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6dc3e5c3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "home_box" }

import { onMounted, reactive, ref, watch } from "vue";
import { api_cw_get_finance_list, api_cw_balance_inquiry, api_cw_pay_check, api_cw_hd_check, api_cw_get_balance_list, api_cw_dk_cl } from '@/api/home';
import { message, type TableColumnsType } from 'ant-design-vue';

import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';

import type { Dayjs } from 'dayjs';

import router from "@/router";

type RangeValue = [Dayjs, Dayjs];

export default /*#__PURE__*/_defineComponent({
  __name: 'DetailedInquiry',
  setup(__props) {

let date = ref<any>([]);


const value1 = ref<RangeValue>();
let current = ref<number>(1)
let user: any = localStorage.getItem('user') || sessionStorage.getItem('user');
user = JSON.parse(user);

let status = ref<string>('0')


watch(value1, (newValue, oldValue) => {
    if (newValue === null) {
        list.value = [];
        current.value = 1;
        total.value = 1;
    }
})


const popconfirmConfirmFun = async (res: any) => {
    console.log(res.transSeqNb);
    let up = {
        openid: user.openid,
        transSeqNb: res.transSeqNb
    }
    let data = await api_cw_dk_cl(up);
    console.log(data);

}
const popconfirmCancelFun = async () => {
    message.error('已取消')
}


let packageNo = ref('');

onMounted(() => {
    console.log('组件加载');
    // api_cw_balance_inquiryFun();
    date.value[0] = dateFun(new Date().getTime() - 86400000, 0);
    date.value[1] = dateFun(new Date().getTime(), 1);


    finishFun('');




});

const handleChange = (e: any) => {
    console.log(e);
}
const focus = (e: any) => {
    console.log(e);
}
const paginationChange = (e: any) => {

    current.value = e.current;

    finishFun('');
}



let usableBalance = ref(0);
let balance = ref(0);
let lastDayBalance = ref(0);

const open = ref<boolean>(false);


const showModal = () => {
    open.value = true;
};

const handleOk = (e: MouseEvent) => {
    console.log(e);
    open.value = false;
};













const api_cw_balance_inquiryFun = async () => {
    let data: any = await api_cw_balance_inquiry(user.payAccNo, user.openid);
    usableBalance.value = data.usableBalance
    balance.value = data.balance
    lastDayBalance.value = data.lastDayBalance
    console.log(data);

}

// const columns: TableColumnsType = [
//     { title: '转账账号', width: 100, dataIndex: 'recAccNo' },
//     { title: '开户名', width: 100, dataIndex: 'recAccName' },
//     { title: '银行名称', width: 100, dataIndex: 'recBankName' },
//     { title: '转账金额', width: 100, dataIndex: 'amount' },
//     { title: '订单号', width: 100, dataIndex: 'packageNo' },
//     { title: '操作时间', width: 100, dataIndex: 'time' },
//     { title: '状态', width: 100, dataIndex: 'message' },
//     { title: '操作', width: 100, dataIndex: 'Controls' }
// ];


const ReceiptQueryFun = async (item: any) => {
    console.log(item);
    let up = {
        openid: user.openid,
        // accNo: item.recAccNo,
        accNo: user.payAccNo,
        retNo: item.retNo
    }
    let data: any = await api_cw_hd_check(up);
    if (data.error === 0) {
        base64ToPDF('data:application/pdf;base64,' + data.body.billFileContent, 'example.pdf')
    }
}





const columns = [
    {
        title: '交易金额',
        dataIndex: 'amount',
        // width: '15%',
    },
    {
        title: '状态',
        dataIndex: 'drcType',
        width: '100px'
    },
    {
        title: '对方账户名称',
        dataIndex: 'recAccName',
        // width: '15%',
    },
    {
        title: '对方账号',
        dataIndex: 'recAccNo',
        // width: '15%',
    },
    {
        title: '交易流水号',
        dataIndex: 'transSeqNb',
        width: '15%',
    },
    {
        title: '交易日期',
        dataIndex: 'tranDt',
        width: '140px',
    },
    {
        title: '附言',
        dataIndex: 'memo'
    },
    {
        title: '操作',
        dataIndex: 'Controls',
        // width: '15%',
    }
];



const base64ToPDF = (base64String: string, pdfName: string) => {
    let binaryData = atob(base64String.split(',')[1]);
    let mimeString = base64String.split(',')[0].split(':')[1];
    let arrayBuffer = new ArrayBuffer(binaryData.length);
    let uintArray = new Uint8Array(arrayBuffer);
    for (let i = 0; i < binaryData.length; i++) {
        uintArray[i] = binaryData.charCodeAt(i);
    }
    let blob = new Blob([uintArray], { type: mimeString });
    let url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    a.download = pdfName || 'downloadedPDF.pdf';
    // 触发下载
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}








const columnss: TableColumnsType = [
    { title: '转账账号', width: "30%", dataIndex: 'recAccNo' },
    { title: '转账金额', width: "15%", dataIndex: 'amount' },
    { title: '转账状态', width: "30%", dataIndex: 'desc' },
]

let list: any = ref([]);
let dataSource: any = ref([]);

let total: any = ref(1);

const TheInverseDateFun = (str: string): string => {
    let year = str.slice(0, 4) + '年';
    let month = str.slice(4, 6) + '月';
    let day = str.slice(6, 8) + '日';
    let hour = str.slice(8, 10) + '时';
    let minute = str.slice(10, 12) + '分';
    let second = str.slice(12, 14) + '秒';
    return year + month + day + hour + minute + second
}


const finishFun = async (value: any) => {
    list.value = [];
    let up = {
        accNo: user.payAccNo,  //查询银行账号
        pageNo: current.value, //分页 （从1开始）
        beginDate: date.value[0],  //开始时间
        endDate: date.value[1], //结束时间
        openid: user.openid,
        type: status.value
    }
    console.log(up, '------------------');
    let data: any = await api_cw_get_balance_list(up);
    console.log(data);
    if (data) {
        // return
        if (data.header.code === "000000") {
            total.value = data.body.totalNum;
            data.body.details.forEach((item: any) => {
                let obj = {
                    amount: item.amount / 100,
                    recAccNo: item.recAccNo,
                    recAccName: item.recAccName,
                    transSeqNb: item.transSeqNb,
                    tranDt: TheInverseDateFun(item.tranTime),
                    retNo: item.retNo,
                    drcType: item.drcType === 'D' ? '支出' : '收入',
                    memo: item.memo,
                    status: item.status
                }
                list.value.push(obj)
            })
            // for (let index = 0; index < 40; index++) {
            //     const element = data.body.details[0];
            //     // console.log(element);
            //     list.value.push(element)

            // }
        } else {
            if (data.header.msg) message.error(data.header.msg);
        }
    }
}


let pickerChangeFun = (e: any) => {
    console.log(e);

    if (e === null) return
    if (date.value.length === 2) {
        date.value = []
    }
    for (let index = 0; index < e.length; index++) {
        const element = e[index].$d;
        console.log(element);
        let str = dateFun(Date.parse(element), 3)
        date.value.push(str);
    }
}

const StatusQueryFun = async (item: any) => {
    console.log(item);
    dataSource.value = [];

    let up = {
        openid: user.openid,
        queryPacNo: item.packageNo
    }
    console.log(up);

    let data: any = await api_cw_pay_check(up);
    if (data.header.code === '000000') {
        if (data.body.details.length !== 0) {
            open.value = true;
            data.body.details.forEach((item: any) => {

                let obj = {
                    recAccNo: item.recAccNo,
                    amount: item.amount / 100,
                    desc: item.desc
                }
                dataSource.value.push(obj);
            });
            console.log(dataSource.value);
        }
    }
}

const dateFun = (timestamp: number, index: number): string => {
    console.log(timestamp, index);

    var date = new Date(timestamp);
    var year = date.getFullYear();
    var month = (date.getMonth() + 1).toString().padStart(2, '0');
    var day = date.getDate().toString().padStart(2, '0');
    var Hours = date.getHours();
    var Minutes = date.getMinutes()
    return `${year}${month}${day}`
}


return (_ctx: any,_cache: any) => {
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_form, { layout: "inline" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, { label: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_range_picker, {
              value: value1.value,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((value1).value = $event)),
              "show-time": { format: 'HH:mm' },
              locale: _unref(locale),
              format: "YYYY-MM-DD HH:mm",
              onChange: _unref(pickerChangeFun)
            }, null, 8, ["value", "locale", "onChange"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_select, {
              ref: "select",
              value: _unref(status),
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_isRef(status) ? (status).value = $event : status = $event)),
              style: {"width":"100px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select_option, { value: "0" }, {
                  default: _withCtx(() => [
                    _createTextVNode("全部")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_select_option, { value: "1" }, {
                  default: _withCtx(() => [
                    _createTextVNode("收入")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_select_option, { value: "3" }, {
                  default: _withCtx(() => [
                    _createTextVNode("支出")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: finishFun
            }, {
              default: _withCtx(() => [
                _createTextVNode("搜索")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_table, {
        columns: columns,
        "data-source": _unref(list),
        scroll: { y: '580px' },
        onChange: paginationChange,
        pagination: { total: _unref(total), current: _unref(current), pageSize: 10 }
      }, {
        bodyCell: _withCtx(({ column, record }) => [
          (column.dataIndex === 'Controls')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (record.retNo !== '')
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 0,
                      style: {"width":"100px","margin-bottom":"10px"},
                      type: "primary",
                      onClick: ($event: any) => (ReceiptQueryFun(record))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("下载回单")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                (record.drcType !== '支出')
                  ? (_openBlock(), _createBlock(_component_a_popconfirm, {
                      key: 1,
                      title: "是否确认操作?",
                      "ok-text": "确认",
                      "cancel-text": "取消",
                      onConfirm: ($event: any) => (popconfirmConfirmFun(record)),
                      onCancel: popconfirmCancelFun,
                      disabled: record.status === '已处理'
                    }, {
                      default: _withCtx(() => [
                        (record.retNo !== '')
                          ? (_openBlock(), _createBlock(_component_a_button, {
                              key: 0,
                              style: _normalizeStyle([{"width":"100px"}, record.status === '已处理' ? 'background-color:green' : 'background-color:red']),
                              type: "primary"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(record.status === "已处理" ? "已处理" : '确认打款'), 1)
                              ]),
                              _: 2
                            }, 1032, ["style"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["onConfirm", "disabled"]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["data-source", "pagination"])
    ]),
    _createVNode(_component_a_modal, {
      open: open.value,
      "onUpdate:open": _cache[2] || (_cache[2] = ($event: any) => ((open).value = $event)),
      width: "800px",
      title: "查询状态",
      onOk: handleOk,
      footer: null
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_table, {
          columns: columnss,
          scroll: { y: 300 },
          pagination: false,
          "data-source": _unref(dataSource)
        }, null, 8, ["data-source"])
      ]),
      _: 1
    }, 8, ["open"])
  ]))
}
}

})